import styled from "styled-components";

import { PlatformName } from "shared/types/accounts";

import fbIcon from "./icons/fb.image.svg";
import gbIcon from "./icons/gb.image.svg";
import igIcon from "./icons/ig.image.svg";
import lnIcon from "./icons/ln.image.svg";
import piIcon from "./icons/pi.image.svg";
import scIcon from "./icons/sc.image.svg";
import ttIcon from "./icons/tt.image.svg";
import twIcon from "./icons/tw.image.svg";
import ytIcon from "./icons/yt.image.svg";
import ytRedPlayIcon from "./icons/yt-red-play.image.svg";
import otIcon from "./icons/ot.image.svg";
import thIcon from "./icons/th.image.svg";

type PlatformIconName = PlatformName | "youtubeRedPlay";

export const IconMap: Record<PlatformIconName, string> = {
  facebook: fbIcon,
  googlemybusiness: gbIcon,
  instagram: igIcon,
  linkedin: lnIcon,
  pinterest: piIcon,
  snapchat: scIcon,
  tiktok: ttIcon,
  threads: thIcon,
  other: otIcon,
  youtube: ytIcon,
  youtubeRedPlay: ytRedPlayIcon,
  twitter: twIcon,
};

function PlatformIconComponent(props: {
  className?: string;
  type: PlatformIconName | string;
  altText?: string;
}) {
  const icon = IconMap[props.type as PlatformIconName];

  return (
    <Icon
      src={icon}
      className={props.className}
      alt={props.altText || undefined}
    />
  );
}

export const PlatformIcon = styled(PlatformIconComponent)``;

const Icon = styled.img``;
